export default __webpack_public_path__ + "static/media/email-verification.c9631355.svg";